"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Device = void 0;
var Layer_1 = require("./Layer");
var createDOMCanvas_1 = require("./dom/createDOMCanvas");
var Transform_1 = require("./Transform");
/**
 * Represents the graphics rendering device. Could be a web browser or a Node
 * server environment.
 */
var Device = /** @class */ (function () {
    /**
     * @param createCanvas Callback for creating a new, blank canvas.
     * @param pixelRatio See {@link https://developer.mozilla.org/docs/Web/API/Window/devicePixelRatio}
     * @param transform Used to transform the coordinate system to screen space.
     */
    function Device(createCanvas, pixelRatio, transform) {
        if (pixelRatio === void 0) { pixelRatio = 1; }
        if (transform === void 0) { transform = Transform_1.Transform.none(); }
        this.createCanvas = createCanvas;
        this.pixelRatio = pixelRatio;
        this.transform = transform;
    }
    // Maintenance notice:
    //
    // This object gets passed way down the pipeline, so despite its generic name,
    // it should be kept small and certainly not keep any mutable state.
    /**
     * Shortcut to construct a browser-based device.
     *
     * @param transform Used to transform the coordinate system to screen space.
     */
    Device.browser = function (transform) {
        return new Device(createDOMCanvas_1.createDOMCanvas, window.devicePixelRatio || 1, transform);
    };
    /**
     * Creates a drawing surface.
     */
    Device.prototype.createLayer = function () {
        return new Layer_1.Layer(this);
    };
    /**
     * @see transform
     */
    Device.prototype.scale = function (ctx) {
        ctx.scale(this.transform.scale.x, this.transform.scale.y);
    };
    /**
     * @see transform
     */
    Device.prototype.translate = function (ctx) {
        ctx.translate(this.transform.translate.x, this.transform.translate.y);
    };
    return Device;
}());
exports.Device = Device;
//# sourceMappingURL=Device.js.map